import { graphql } from 'app/generated/gql'

export const FILE_IMPORTS_QUERY = graphql(`
  query FileImports($search: String, $pagination: PaginationInput, $sort: SortInput) {
    fileImports(search: $search, pagination: $pagination, sort: $sort) {
      hits {
        id
        orgId
        workspaceId
        fileName
        importIds
        archived
        createdDate
        updatedDate
      }
      total
      page
    }
  }
`)

export const FILE_IMPORT_QUERY = graphql(`
  query FileImport($id: ID!) {
    fileImport(id: $id) {
      id
      orgId
      workspaceId
      fileName
      importIds
      archived
      createdDate
      updatedDate
    }
  }
`)

export const DELETE_FILE_IMPORT_MUTATION = graphql(`
  mutation DeleteFileImport($id: ID!) {
    deleteFileImport(id: $id)
  }
`)

// Query for individual imports within a file import
export const IMPORTS_QUERY = graphql(`
  query Imports($search: String, $pagination: PaginationInput, $sort: SortInput) {
    imports(search: $search, pagination: $pagination, sort: $sort) {
      hits {
        id
        orgId
        workspaceId
        locationId
        fileImportId
        name
        type
        vendor
        email
        phone
        activityDate
        requestedAppointmentTime
        treatment
        isScheduled
        channel
        utmSource
        utmMedium
        utmCampaign
        staff
        createdDate
        updatedDate
      }
      total
      page
    }
  }
`)

export const IMPORT_DETAIL_QUERY = graphql(`
  query ImportDetail($id: ID!) {
    importDetail(id: $id) {
      vendor
      name
      requestedAppointmentTime
      isScheduled
      phone
      email
      treatment
      channel
      staff
    }
  }
`)

export const CREATE_IMPORT_MUTATION = graphql(`
  mutation CreateImport($input: CreateImportInput!) {
    createImport(input: $input) {
      id
    }
  }
`)

export const CREATE_FILE_IMPORT_MUTATION = graphql(`
  mutation CreateFileImport($input: CreateFileImportInput!) {
    createFileImport(input: $input) {
      id
    }
  }
`)
